import React from "react";
import ModalLayout from "app/components/Layouts/ModalLayout/ModalLayout";
import { useTranslation } from "react-i18next";
import styles from "./ContactCoachModal.module.scss";
import closeIcon from "../../../../public/images/close-icon.svg";
import phoneIcon from "../assets/phone.svg";
import mailIcon from "../assets/mail.svg";

interface ContactCoachModalProps {
  isOpen: boolean;
  onClose: () => void;
  phone?: string;
  email?: string;
  coachName?: string;
}

const ContactCoachModal: React.FC<ContactCoachModalProps> = ({
  isOpen,
  onClose,
  phone,
  email,
  coachName,
}) => {
  const { t } = useTranslation();

  return (
    <ModalLayout
      isOpen={isOpen}
      onClose={onClose}
      classNames={styles.modal}
      wrapperClassName={styles.wrapper}
    >
      <div className={styles.header}>
        <h3 className={styles.title}>{t("Contact Coach")}</h3>
        <button
          type="button"
          className={styles.closeButton}
          onClick={onClose}
          aria-label={t("Close")}
        >
          <img src={closeIcon} alt="" className={styles.closeIcon} />
        </button>
      </div>

      {coachName && <p className={styles.name}>{coachName}</p>}

      {phone && (
        <a className={styles.item} href={`tel:${phone}`}>
          <div className={styles.iconWrapper}>
            <img src={phoneIcon} alt="Phone" className={styles.icon} />
          </div>
          <span className={styles.text}>{phone}</span>
        </a>
      )}
      {email && (
        <a className={styles.item} href={`mailto:${email}`}>
          <div className={styles.iconWrapper}>
            <img src={mailIcon} alt="Email" className={styles.icon} />
          </div>
          <span className={styles.text}>{email}</span>
        </a>
      )}
      {!phone && !email && (
        <p className={styles.empty}>{t("No contact information available.")}</p>
      )}
    </ModalLayout>
  );
};

export default ContactCoachModal;
